var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-18"},[_c('div',{staticClass:"font-40 mb-6"},[_vm._v("Page not found!")]),_c('v-btn',{attrs:{"to":"/","color":"#C71010","outlined":""}},[_c('div',[_vm._v("Go to home page")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }